import { pipe, prop } from 'ramda';

import { journeysSelector } from '../selectors';

// eslint-disable-next-line import/prefer-default-export
export const insuranceContractsSelector = pipe(
  journeysSelector,
  prop('insuranceContracts')
);
